import {VARIANTS} from "@components/ui/constants";

const overrideLoadingButtonStyles = () => ({
    MuiLoadingButton: {
        defaultProps: {
            disableElevation: true,
            variant: VARIANTS.CONTAINED,
            color: "primary",
            size: "medium",
        },

        variants: [{
            props: { loading: true, loadingPosition: 'start', size: 'small' },
            style: {
                '& .MuiLoadingButton-loadingIndicatorStart': {
                    left: 10
                }
            }
        }, {
            props: { loading: true, loadingPosition: 'end', size: 'small' },
            style: {
                '& .MuiLoadingButton-loadingIndicatorEnd': {
                    right: 10
                }
            }
        }],

        styleOverrides: {
            loadingIndicatorStart: {
                left: 14
            },
            loadingIndicatorEnd: {
                right: 14
            },
        },
    }
})

export default overrideLoadingButtonStyles